import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon } from 'lucide-react';
const Terms = () => {
  return <div className="min-h-screen flex flex-col bg-cream" data-id="element-669">
      {/* Header */}
      <header className="p-4 bg-white shadow-sm" data-id="element-670">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex justify-between items-center" data-id="element-671">
          <Link to="/" className="text-burgundy font-display text-2xl font-bold" data-id="element-672">
            Chef<span className="text-sage" data-id="element-673">Chat</span>
          </Link>
          <Link to="/" className="text-charcoal hover:text-burgundy flex items-center text-sm font-medium" data-id="element-674">
            <ArrowLeftIcon size={16} className="mr-1" data-id="element-675" />
            Back to home
          </Link>
        </div>
      </header>
      {/* Main content */}
      <main className="flex-grow py-12 px-4" data-id="element-676">
        <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-md p-8" data-id="element-677">
          <h1 className="text-3xl md:text-4xl font-bold text-charcoal font-display mb-4" data-id="element-678">
            Terms of Service
          </h1>
          <p className="text-sage mb-8" data-id="element-679">
            Last updated: {new Date().toLocaleDateString()}
          </p>
          <div className="prose prose-lg max-w-none text-charcoal" data-id="element-680">
            <section className="mb-8" data-id="element-681">
              <h2 className="text-2xl font-bold text-burgundy mb-4" data-id="element-682">
                1. Acceptance of Terms
              </h2>
              <p className="mb-4" data-id="element-683">
                By accessing or using ChefChat ("Service"), you agree to be
                bound by these Terms of Service ("Terms"). If you do not agree
                to these Terms, please do not use our Service.
              </p>
            </section>
            <section className="mb-8" data-id="element-684">
              <h2 className="text-2xl font-bold text-burgundy mb-4" data-id="element-685">
                2. Description of Service
              </h2>
              <p className="mb-4" data-id="element-686">
                ChefChat provides AI-powered customer communication management
                specifically designed for restaurants. Our Service includes
                automated responses to customer inquiries across social media
                platforms, review management, reservation assistance, and
                multi-channel communication coordination—all while preserving
                your restaurant's unique voice and authentic hospitality.
              </p>
            </section>
            <section className="mb-8" data-id="element-687">
              <h2 className="text-2xl font-bold text-burgundy mb-4" data-id="element-688">
                3. Free Trial and Subscription
              </h2>
              <p className="mb-4" data-id="element-689">
                We offer a 14-day free trial for new users. After the trial
                period, continued use of the Service requires a paid
                subscription. You may cancel at any time during the trial period
                without charge.
              </p>
              <p className="mb-4" data-id="element-690">
                Subscription fees are billed in advance on a monthly or annual
                basis. All fees are non-refundable except as required by law.
              </p>
            </section>
            <section className="mb-8" data-id="element-691">
              <h2 className="text-2xl font-bold text-burgundy mb-4" data-id="element-692">
                4. User Accounts and Restaurant Information
              </h2>
              <p className="mb-4" data-id="element-693">
                You are responsible for maintaining the confidentiality of your
                account credentials and for all activities that occur under your
                account. You agree to notify us immediately of any unauthorized
                use of your account.
              </p>
              <p className="mb-4" data-id="element-694">
                You are responsible for providing accurate information about
                your restaurant, including menu details, hours of operation,
                policies, and any other information necessary for ChefChat to
                provide accurate customer responses.
              </p>
            </section>
            <section className="mb-8" data-id="element-695">
              <h2 className="text-2xl font-bold text-burgundy mb-4" data-id="element-696">
                5. Social Media and Platform Connections
              </h2>
              <p className="mb-4" data-id="element-697">
                To use our Service, you authorize ChefChat to access and respond
                to customer communications on your behalf through connected
                platforms including Facebook, Instagram, Google Reviews, Yelp,
                and other integrated channels.
              </p>
              <p className="mb-4" data-id="element-698">
                You retain full ownership and control of your social media
                accounts and can revoke ChefChat's access at any time. You are
                responsible for ensuring compliance with each platform's terms
                of service.
              </p>
            </section>
            <section className="mb-8" data-id="element-699">
              <h2 className="text-2xl font-bold text-burgundy mb-4" data-id="element-700">
                6. AI-Generated Responses and Owner Oversight
              </h2>
              <p className="mb-4" data-id="element-701">
                ChefChat uses artificial intelligence to generate responses to
                customer inquiries. While we strive for accuracy and
                authenticity, you maintain responsibility for reviewing and
                approving responses before they are sent to customers.
              </p>
              <p className="mb-4" data-id="element-702">
                You acknowledge that AI-generated content may occasionally
                require human oversight and correction. ChefChat is designed to
                assist, not replace, your judgment and authentic voice.
              </p>
            </section>
            <section className="mb-8" data-id="element-703">
              <h2 className="text-2xl font-bold text-burgundy mb-4" data-id="element-704">
                7. Acceptable Use
              </h2>
              <p className="mb-4" data-id="element-705">You agree not to:</p>
              <ul className="list-disc pl-6 mb-4" data-id="element-706">
                <li data-id="element-707">Use the Service for any illegal purpose</li>
                <li data-id="element-708">
                  Provide false or misleading information about your restaurant
                </li>
                <li data-id="element-709">Attempt to gain unauthorized access to our systems</li>
                <li data-id="element-710">Interfere with or disrupt the Service</li>
                <li data-id="element-711">Share your account credentials with others</li>
                <li data-id="element-712">Use the Service to distribute spam or malicious content</li>
                <li data-id="element-713">
                  Violate any third-party platform's terms of service through
                  our Service
                </li>
              </ul>
            </section>
            <section className="mb-8" data-id="element-714">
              <h2 className="text-2xl font-bold text-burgundy mb-4" data-id="element-715">
                8. Content and Data Ownership
              </h2>
              <p className="mb-4" data-id="element-716">
                You retain ownership of all restaurant information, customer
                communications, and content you provide to ChefChat. By using
                our Service, you grant us a license to use, store, and process
                this information solely to provide and improve our Service.
              </p>
              <p className="mb-4" data-id="element-717">
                ChefChat may use anonymized, aggregated data to improve our AI
                models and Service quality, but will never share your specific
                restaurant data or customer information with third parties
                without your explicit consent.
              </p>
            </section>
            <section className="mb-8" data-id="element-718">
              <h2 className="text-2xl font-bold text-burgundy mb-4" data-id="element-719">
                9. Service Availability and Limitations
              </h2>
              <p className="mb-4" data-id="element-720">
                While we strive to provide 24/7 service availability, we do not
                guarantee uninterrupted access. The Service may be temporarily
                unavailable due to maintenance, updates, or circumstances beyond
                our control.
              </p>
              <p className="mb-4" data-id="element-721">
                Message volume limits apply based on your subscription tier.
                Additional messages beyond your plan limit may incur additional
                charges as specified in your subscription agreement.
              </p>
            </section>
            <section className="mb-8" data-id="element-722">
              <h2 className="text-2xl font-bold text-burgundy mb-4" data-id="element-723">
                10. Disclaimers
              </h2>
              <p className="mb-4" data-id="element-724">
                ChefChat provides communication management tools and AI-assisted
                responses. We are not responsible for the ultimate content of
                responses sent from your accounts, business decisions made based
                on our analytics, or outcomes of customer interactions.
              </p>
              <p className="mb-4" data-id="element-725">
                The Service is provided "as is" without warranties of any kind,
                either express or implied. We do not guarantee that AI responses
                will be error-free or that the Service will meet all your
                business needs.
              </p>
            </section>
            <section className="mb-8" data-id="element-726">
              <h2 className="text-2xl font-bold text-burgundy mb-4" data-id="element-727">
                11. Limitation of Liability
              </h2>
              <p className="mb-4" data-id="element-728">
                To the maximum extent permitted by law, ChefChat shall not be
                liable for any indirect, incidental, special, consequential, or
                punitive damages resulting from your use of or inability to use
                the Service, including but not limited to lost revenue, missed
                reservations, or damage to your restaurant's reputation.
              </p>
              <p className="mb-4" data-id="element-729">
                Our total liability to you for any claims arising from your use
                of the Service shall not exceed the amount you paid us in the
                twelve months preceding the claim.
              </p>
            </section>
            <section className="mb-8" data-id="element-730">
              <h2 className="text-2xl font-bold text-burgundy mb-4" data-id="element-731">
                12. Modifications to Service and Terms
              </h2>
              <p className="mb-4" data-id="element-732">
                We reserve the right to modify or discontinue the Service at any
                time. We may also update these Terms from time to time.
                Continued use of the Service after changes constitutes
                acceptance of the modified Terms. We will notify you of material
                changes via email or through the Service.
              </p>
            </section>
            <section className="mb-8" data-id="element-733">
              <h2 className="text-2xl font-bold text-burgundy mb-4" data-id="element-734">
                13. Termination
              </h2>
              <p className="mb-4" data-id="element-735">
                Either party may terminate this agreement at any time. You may
                cancel your subscription through your account settings. We may
                terminate or suspend your account for violation of these Terms
                or for any reason at our sole discretion, with or without
                notice.
              </p>
              <p className="mb-4" data-id="element-736">
                Upon termination, you will lose access to the Service and any
                data stored within it. We recommend exporting any important data
                before cancellation.
              </p>
            </section>
            <section className="mb-8" data-id="element-737">
              <h2 className="text-2xl font-bold text-burgundy mb-4" data-id="element-738">
                14. Governing Law
              </h2>
              <p className="mb-4" data-id="element-739">
                These Terms shall be governed by and construed in accordance
                with the laws of the jurisdiction in which ChefChat operates,
                without regard to its conflict of law provisions.
              </p>
            </section>
            <section className="mb-8" data-id="element-740">
              <h2 className="text-2xl font-bold text-burgundy mb-4" data-id="element-741">
                15. Contact Information
              </h2>
              <p className="mb-4" data-id="element-742">
                If you have any questions about these Terms, please contact us
                at support[at]getchefchat.com.
              </p>
            </section>
          </div>
        </div>
      </main>
      {/* Footer */}
      <footer className="p-4 bg-white border-t border-gray-200 mt-auto" data-id="element-743">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-sm text-sage" data-id="element-744">
          <p data-id="element-745">© 2024 ChefChat. All rights reserved.</p>
        </div>
      </footer>
    </div>;
};
export default Terms;